import * as actionTypes from '../actions/actionTypes';

export default function (state = null, action) {
  switch (action.type) {
    case actionTypes.FETCH_FINANCIAL_SUCCESS:
      return action.financial;
    case actionTypes.UPSERT_FINANCIAL_SUCCESS:
      return action.financial;
    default:
      return state;
  }
}
